// src/validation-schemas/change-password-schema.ts
import { z } from "zod";

const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

export const changePasswordSchema = z
    .object({
        password: z
            .string()
            .nonempty("Password is required")
            .min(8, "Password must be at least 8 characters long.")
            .regex(
                strongPasswordRegex,
                "Password must include at least one uppercase letter, one lowercase letter, one number, and one special character."
            ),

        newPassword: z
            .string()
            .nonempty("Password is required")
            .min(8, "Password must be at least 8 characters long.")
            .regex(
                strongPasswordRegex,
                "Password must include at least one uppercase letter, one lowercase letter, one number, and one special character."
            ),

        confirmPassword: z
            .string()
            .nonempty("Confirm password is required")
            .min(8, "Confirm password must be at least 8 characters long."),
    })
    .refine((data) => data.newPassword === data.confirmPassword, {
        message: "Passwords do not match.",
        path: ["confirmPassword"],
    });




export type ChangePasswordSchema = z.infer<typeof changePasswordSchema>;
